<template>
  <div class="clock clock-modal">
    <div class="clock-content">
      <div class="loading"
           v-if="currentshow===0">数据加载中...</div>
      <div class="clock-tips"
           v-if="currentshow===1">
        <p class="txt-t">暂无添加闹钟</p>
        <p class="txt-p">您可以添加闹钟来提醒自己及时入住新服，参与副<br />本，攻城/跨服、刷BOSS等</p>
        <a href="javascript:;"
           @click="addClockSetting('add')"
           class="btnNml">添加闹钟</a>
      </div>
      <div class="clock-setting"
           v-if="currentshow===2">
        <a-form :form="form"
                :layout="formLayout"
                @submit="handleSubmit">
          <a-form-item :label-col="labelCol"
                       :wrapper-col="wrapperCol"
                       label="游戏/区服">
            <a-form-item :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }">
              <a-select placeholder="请选择游戏"
                        showSearch
                        labelInValue
                        v-decorator="['game_code',{rules: [{ required: true, message: '请选择游戏!' }] }]"
                        @change="handleGameChange">
                <a-select-option v-for="game in gamelistData"
                                 :key="game.game_code">{{game.game_name}}</a-select-option>
              </a-select>
            </a-form-item>
            <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }"></span>
            <a-form-item :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }">
              <a-select placeholder="请选择区服"
                        showSearch
                        labelInValue
                        v-decorator="['server_id',{ rules: [{ required: true, message: '请选择区服!' }] }]">
                <a-select-option v-for="server in serverlistDta"
                                 :key="server.server_id">{{server.server_name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-form-item>
          <a-form-item :label-col="labelCol"
                       :wrapper-col="wrapperCol"
                       label="时间：">
            <a-form-item :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }">
              <a-date-picker style="width: 100%"
                             placeholder="请选择日期"
                             v-decorator="['day',{ rules: [{ required: true, message: '请选择日期!' }] }]" />
            </a-form-item>
            <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }"></span>
            <a-form-item :style="{ display: 'inline-block', width: 'calc(25% - 12px)' }">
              <a-time-picker style="width: 100%"
                             v-decorator="['hour',{ rules: [{ required: true, message: '请选择时钟!' }] }]"
                             format="HH"
                             placeholder="时"
                             :open.sync="open1"
                             @change="handleClose1">
              </a-time-picker>
            </a-form-item>
            <span :style="{ display: 'inline-block', width: '12px', textAlign: 'center' }"></span>
            <a-form-item :style="{ display: 'inline-block', width: 'calc(25% - 12px)' }">
              <a-time-picker style="width: 100%"
                             v-decorator="['minute',{ rules: [{ required: true, message: '请选择分钟!' }] }]"
                             format="mm"
                             placeholder="分"
                             :open.sync="open2"
                             @change="handleClose2">
              </a-time-picker>
            </a-form-item>
          </a-form-item>
          <a-form-item :label-col="labelCol"
                       :wrapper-col="wrapperCol"
                       label="备注：">
            <a-input placeholder="请输入需要提醒的信息，如：攻城/跨服"
                     v-decorator="['remark',{rules: [{ required: false}] }]" />
          </a-form-item>
          <a-form-item :wrapper-col="{
                       xs: { span: 24, offset: 0 },
                       sm: { span: 19, offset: 5 },
                       }">
            <a-checkbox :checked="checked"
                        @change="onChange">
              每天提醒
            </a-checkbox>
          </a-form-item>
          <div class="btns">
            <a-button type="primary"
                      html-type="submit"
                      class="btnNml">
              确认添加
            </a-button>
          </div>
        </a-form>
      </div>
      <div class="clock-lists"
           v-if="currentshow===3">
        <ul>
          <li v-for="item in clockSettingList"
              :key="item.id">
            <div class="row">
              <div class="col col-1">
                <a class="javascript:;">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       xmlns:xlink="http://www.w3.org/1999/xlink"
                       width="36px"
                       height="34px">
                    <image x="0px"
                           y="0px"
                           width="36px"
                           height="34px"
                           xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAiCAQAAACdULMOAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfjDAsPDRIDvuG0AAADgklEQVRIx5XWe2iVdRzH8dc5O5vzQjmjxJqBZk4zFXOZNdIcmQwXoTVBGGH2RybaRQIpTaIixyHLMi9B2exmF9YGByxFDYWY/iGkUiqumXjBEXOi87JNZ388z3k8c8eanz8Ov+/n93zfz/d3eX6/E6sS6hFlhup0SMpe/617lCuWcNIm2wIrVgWFPvFUxoPLvBO1B8jBFacjZ5av5EXRNi86HIAK/WJU1HHGSp86ZahSUwxTKBcdjmvwq+0a5auwRFGUcdQ0h2JVMSnTI3Oref7ygNc8qV+WQbVKWWGPvpZbGLk7lcaVZGA+MFWTtXabnRVDP7PVWy3XS553KXQnmZLImJvFkh60wcgwPq/eLgc14zYjTPSwvsg13xTPWe+0jfJBecKQMC0pqdSPBoAWa1RruK6eYeaYrwAjbfK0OvNUg8FxV8DPFntITYipVWxpiOltgQV6gQZLFasNV/MnE2zwEbgU9wdavKDAt/qDd83UGFWxyCqrvBrFjWZ6DxT40gCvO4Df4+qwwjFJQ0PMm12GMwIytgcsCVFFqlz0tvNq4vZ5wzoTzAU112HoyPjNRKXAXBPVmq0xjuWaLRZHi5f1VAudQY5F2qSIgyHKwBonegw6ajWYHqx7ACrTG60+6zEGPncBfUy7BnoM7Pb3DZOuZvGOqAelaVDCcPDbTdWDEHSvHBK4xR3QbR9nqswWccRclrI6rPAwGOhWpxNIhKdLc1ZELhhkUOQ8YU9YS5CRJ5Geo4CfkxV0sJtzWWvYCjI6XQ2G1h4eB7dnBb3vjOFiYRRzyWb7wyjIaNMRgM46pZDo+OiqtnC/ZNN94KSzwdA6/QkevakVI6YE7NOZnqPNYJwxNwUaYzzYThq0TQvyMk7hnmiBBJozQU02gsrwHT3ReJXgO03XQHzoHPKt06dHmD7Wycc5KwMjDWqQBMW+kPhfTK5qxSCZ/h5yHk937lJiCEYZaWt00WRTgWoV4TTPD8/8qCLazXIcVNhh6g0xU+3wDDiiQnvajmc8MkNB2Bptizrl4WWQVn/l6mwxOoonX+uMRf9G5lnb7e3H7HVIEwYqMtbg6/o7VPqhK6jETnG0m6O3t7qldMUv06ZaHtpNshvRCt0pjsue9T1S5qp0fxbIft9Y7x90+lpCnrsDULqifEljfawmSullnMnGuEs+Ljphn532ZFxMM7zigEUuwL+z3u6Eq5PegAAAAABJRU5ErkJggg==" />
                  </svg>
                </a>
              </div>
              <div class="col col-2">
                <p>{{item.game_name}}-{{item.server_name}}</p>
                <p>提醒时间：
                  <span class="txt-yellow"
                        v-if="!item.remind">{{item.day}} {{item.hour}}:{{item.minute}}</span>
                  <span class="txt-yellow"
                        v-else>每天{{item.hour}}:{{item.minute}}</span>
                </p>
                <p>备注：{{item.remark}}</p>
              </div>
              <div class="col col-3">
                <a href="javascript:;"
                   @click="addClockSetting('edit',item)">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       xmlns:xlink="http://www.w3.org/1999/xlink"
                       width="21px"
                       height="20px">
                    <path fill-rule="evenodd"
                          fill="rgb(136, 136, 136)"
                          d="M19.715,4.718 L10.762,13.695 C10.545,13.913 10.255,14.001 9.970,13.982 C9.950,13.983 9.934,13.992 9.914,13.992 L7.065,13.992 C7.062,13.992 7.060,13.991 7.056,13.991 C7.037,13.992 7.020,14.003 7.000,14.003 C6.783,14.003 6.594,13.911 6.431,13.782 C6.168,13.601 5.986,13.325 5.986,13.000 C5.986,12.954 6.007,12.916 6.014,12.872 L6.014,10.083 C6.014,10.063 6.023,10.047 6.024,10.027 C6.008,9.746 6.097,9.461 6.312,9.246 L15.265,0.294 C15.374,0.184 15.504,0.111 15.641,0.062 C16.017,-0.094 16.466,-0.020 16.772,0.286 L19.710,3.225 C19.917,3.432 20.015,3.705 20.011,3.976 C20.015,4.244 19.919,4.513 19.715,4.718 ZM15.998,2.452 L7.986,10.463 L7.986,12.007 L9.554,12.007 L17.542,3.996 L15.998,2.452 ZM2.000,6.000 L2.000,16.000 C2.000,17.104 2.895,18.000 4.000,18.000 L14.000,18.000 C15.104,18.000 16.000,17.104 16.000,16.000 L16.000,10.000 L18.000,10.000 L18.000,18.000 C18.000,19.104 17.104,20.000 16.000,20.000 L2.000,20.000 C0.895,20.000 -0.000,19.104 -0.000,18.000 L-0.000,4.000 C-0.000,2.895 0.895,2.000 2.000,2.000 L10.000,2.000 L10.000,4.000 L4.000,4.000 C2.895,4.000 2.000,4.895 2.000,6.000 Z" />
                  </svg>
                </a>
                <a href="javascript:;"
                   @click="deleteClockList(item.id)">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       xmlns:xlink="http://www.w3.org/1999/xlink"
                       width="18px"
                       height="20px">
                    <path fill-rule="evenodd"
                          fill="rgb(136, 136, 136)"
                          d="M17.000,6.000 L16.000,6.000 L16.000,8.000 L16.000,16.000 C16.000,18.209 14.209,20.000 12.000,20.000 L6.000,20.000 C3.791,20.000 2.000,18.209 2.000,16.000 L2.000,8.000 L2.000,6.000 L1.000,6.000 C0.448,6.000 -0.000,5.552 -0.000,5.000 C-0.000,4.448 0.448,4.000 1.000,4.000 L2.000,4.000 L2.000,4.000 L5.000,4.000 C5.000,1.791 6.791,-0.000 9.000,-0.000 C11.209,-0.000 13.000,1.791 13.000,4.000 L16.000,4.000 L16.000,4.000 L17.000,4.000 C17.552,4.000 18.000,4.448 18.000,5.000 C18.000,5.552 17.552,6.000 17.000,6.000 ZM9.000,2.000 C7.895,2.000 7.000,2.895 7.000,4.000 L11.000,4.000 C11.000,2.895 10.105,2.000 9.000,2.000 ZM14.000,6.000 L4.000,6.000 L4.000,14.000 C4.000,16.209 5.791,18.000 8.000,18.000 L10.000,18.000 C12.209,18.000 14.000,16.209 14.000,14.000 L14.000,6.000 ZM12.000,15.000 C11.448,15.000 11.000,14.552 11.000,14.000 L11.000,9.000 C11.000,8.448 11.448,8.000 12.000,8.000 C12.552,8.000 13.000,8.448 13.000,9.000 L13.000,14.000 C13.000,14.552 12.552,15.000 12.000,15.000 ZM9.000,15.000 C8.448,15.000 8.000,14.552 8.000,14.000 L8.000,9.000 C8.000,8.448 8.448,8.000 9.000,8.000 C9.552,8.000 10.000,8.448 10.000,9.000 L10.000,14.000 C10.000,14.552 9.552,15.000 9.000,15.000 ZM6.000,15.000 C5.448,15.000 5.000,14.552 5.000,14.000 L5.000,9.000 C5.000,8.448 5.448,8.000 6.000,8.000 C6.552,8.000 7.000,8.448 7.000,9.000 L7.000,14.000 C7.000,14.552 6.552,15.000 6.000,15.000 Z" />
                  </svg>
                </a>
              </div>
            </div>
          </li>
        </ul>
        <a-pagination :defaultCurrent="currentpage"
                      :current="currentpage"
                      hideOnSinglePage
                      :defaultPageSize="2"
                      :total="totallist"
                      @change="changePage"
                      size="small" />
        <a href="javascript:;"
           @click="addClockSetting('add')"
           class="btnNml">添加闹钟</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClockSetting',
  data () {
    return {
      formLayout: 'horizontal',
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      currentshow: 0,
      currentpage: 1,
      totalpage: 0,
      totallist: 0,
      serverlistDta: [],
      gamelistData: [],
      clockSettingList: [],
      token: '',
      id: '',
      checked: false,
      open1: false,
      open2: false
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  mounted () {
    this.Storage.get('USER', res => {
      if (res.status === 'error' || !res.data.USER) {
        return
      }
      this.token = res.data.USER.box_token
    })
    this.getClockSettingList()
  },
  methods: {
    handleClose1 () {
      this.open1 = false
    },
    handleClose2 () {
      this.open2 = false
    },
    // 判断闹钟列表
    getClockSettingList () {
      let t = this
      t.XHR({
        url: t.ports.clock.list,
        data: {
          page: t.currentpage,
          token: t.token
        },
        cbFn (res) {
          if (res.status === 'error') {
            t.Toast({
              content: res.info
            })
            return
          }
          if (res.data.count < 1) {
            t.currentshow = 1
            t.getAllGame()
            return
          }
          t.clockSettingList = res.data.list
          t.toalpage = res.data.count_page
          t.totallist = res.data.count
          t.currentpage = parseInt(res.data.current_page)
          t.currentshow = 3
        }
      })
    },
    checkClockSetting () {
      let t = this
      t.XHR({
        url: t.ports.clock.check,
        data: {
          token: t.token
        },
        cbFn (res) {
          if (res.status === 'error') {
            return
          }
          t.$store.commit('FNSTATE', {
            clockData: res.data.list
          })
        }
      })
    },
    changePage (page, pageSize) {
      let t = this
      if (page === t.currentpage) {
        return false
      }
      t.currentpage = page
      this.getClockSettingList()
    },
    // 获取游戏列表
    getAllGame () {
      let t = this
      t.XHR({
        url: t.ports.user.slaveAllGame,
        cbFn (res) {
          if (res.status === 'error') {
            t.Toast({
              content: res.info
            })
            return
          }
          t.gamelistData = res.data
        }
      })
    },
    // 获取区服列表
    handleGameChange (value) {
      let t = this
      t.XHR({
        url: t.ports.user.slaveAllServer,
        data: {
          game_code: value.key
        },
        cbFn (res) {
          if (res.status === 'error') {
            t.Toast({
              content: res.info
            })
            return
          }
          if (res.data.length < 1) {
            t.form.setFieldsValue({
              'server_id': ''
            })
            t.serverlistDta = []
            return false
          }
          t.serverlistDta = res.data
        }
      })
    },
    // 添加/编辑闹钟
    addClockSetting (type, item) {
      let t = this
      t.currentshow = 2
      t.getAllGame()
      if (type === 'edit') {
        t.id = item.id
        t.handleGameChange({ key: item.game_code })
        setTimeout(() => {
          if (item.remind) {
            t.checked = true
          } else {
            t.checked = false
          }
          t.form.setFieldsValue({
            'game_code': { key: item.game_code },
            'server_id': { key: item.server_id },
            'day': t.moment(item.day, 'YYYY-MM-DD'),
            'hour': t.moment(item.hour, 'HH'),
            'minute': t.moment(item.minute, 'mm'),
            'remark': item.remark,
            'remind': t.cheked ? 1 : 0
          })
        }, 1000)
      } else {
        t.id = ''
      }
    },
    // 删除闹钟列表
    deleteClockList (id) {
      let t = this
      t.$confirm({
        title: '你确定要删除吗?',
        content: '',
        centered: true,
        cancelText: '取消',
        okText: '确定',
        onOk () {
          t.XHR({
            url: t.ports.clock.delete,
            data: {
              id: id
            },
            cbFn (res) {
              t.Toast({
                content: res.info
              })
              if (res.status === 'error') {
                return false
              }
              t.currentpage = 1
              t.checkClockSetting()
              t.getClockSettingList()
            }
          })
        },
        onCancel () {
        },
        class: 'test'
      })
    },
    // 表单提交
    handleSubmit (e) {
      let t = this
      e.preventDefault()
      this.form.validateFields((err, fieldsValue) => {
        if (err) {
          return
        }
        const values = {
          ...fieldsValue,
          'game_code': fieldsValue['game_code'].key,
          'server_id': fieldsValue['server_id'].key,
          'token': t.token,
          'day': fieldsValue['day'].format('YYYY-MM-DD'),
          'hour': fieldsValue['hour'].format('HH'),
          'minute': fieldsValue['minute'].format('mm'),
          'remind': t.checked ? 1 : 0,
          'id': t.id
        }
        t.XHR({
          url: t.ports.clock.add,
          method: 'post',
          data: values,
          cbFn: res => {
            t.Toast({
              content: res.info
            })
            if (res.status === 'error') {
              return false
            }
            t.checkClockSetting()
            t.getClockSettingList()
            t.currentpage = 1
          }
        })
      })
    },
    onChange (e) {
      this.checked = e.target.checked
    }
  }
}
</script>

<style lang="less" scoped>
.clock {
  color: #555555;
  .loading {
    display: flex;
    height: 268px;
    align-items: center;
    justify-content: center;
  }
  &-tips {
    text-align: center;
    .txt-t {
      margin-top: 56px;
      font-size: 16px;
    }
    .txt-p {
      line-height: 28px;
      color: #888888;
    }
  }
  &-lists {
    text-align: center;
    li {
      width: 418px;
      height: 90px;
      padding: 0 15px;
      background: #f7f7f7;
      margin: 0 auto 10px;
      text-align: left;
    }
    .row {
      display: flex;
      height: 100%;
      align-items: center;
      .col {
        &-2 {
          width: 70%;
          margin-left: 15px;
          p {
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            overflow: hidden;
          }
        }
        &-3 {
          a {
            margin-left: 10px;
            &:hover {
              svg path {
                fill: #f58d16;
              }
            }
          }
        }
      }
    }
    p {
      margin-bottom: 0;
    }
    .btnNml {
      margin-top: 10px;
    }
  }
  &-setting {
    padding: 10px 30px;
    .btns {
      margin-top: 20px;
    }
  }
  .btnNml {
    width: 100px;
    height: 30px;
    line-height: 30px;
    border-radius: 3px;
    &:hover {
      color: #fff;
    }
  }
}
.btns {
  text-align: center;
}
.form {
  .item {
    display: flex;
    align-items: center;
    height: 36px;
    .label {
      width: 75px;
      text-align: right;
    }
    &-4 {
      text-align: center;
    }
  }
}
.txt-yellow {
  color: #fd9d2b;
}
</style>
